<template>
  <div>
    <create-study-set-overview :studysetDetails="studysetDetails" :organizationType="organizationType" :organizationId="organizationId" :uploadId="uploadId" @update:uploadId="$emit('update:uploadId', $event)" />
    <api-errors :errors="errors" />
    <study-set-create-footer
      v-if="!review"
      :cancelActive="true"
      :primaryPreviousActive="true"
      :primaryTextShowIcon="false"
      :previousShowIcon="true"
      :primaryAction="createClass"
      :primaryPreviousAction="editClass"
      :primaryCancelAction="cancelClass"
      :primaryText="$t('study_sets.create_study_set')"
      :primaryPreviousText="$t('study_sets.create_studyset_flow.previous')"
    />
    <study-set-create-footer
      v-else
      :primaryTextShowIcon="false"
      :cancelActive="true"
      :previousShowIcon="false"
      :primaryPreviousActive="true"
      :primaryPreviousAction="reviewDone"
      :primaryAction="assignToClass"
      :primaryCancelAction="reviewDone"
      :primaryPreviousText="$t('common.done')"
      :primaryText="$t($i18nLabelsHelper(currentOrganizationType, `study_sets.assign_to_group`))"
    />
    <!-- <study-set-create-footer
      v-else-if="createdSuccess"
      :primaryTextShowIcon="false"
      :cancelActive="true"
      :primaryPreviousActive="true"
      :primaryPreviousAction="editClass"
      :primaryAction="assignToClass"
      :primaryCancelAction="reviewDone"
      :primaryPreviousText="$t('common.done')"
      :primaryText="$t($i18nLabelsHelper(currentOrganizationType, `study_sets.assign_to_group`))"
    /> -->
    <!-- <study-set-create-footer
      v-else
      :primaryTextShowIcon="false"
      :cancelActive="true"
      :primaryPreviousActive="true"
      :primaryPreviousAction="editClass"
      :primaryAction="assignToClass"
      :primaryCancelAction="reviewDone"
      :primaryPreviousText="$t('common.done')"
      :primaryText="$t($i18nLabelsHelper(currentOrganizationType, `study_sets.assign_to_group`))"
      :primaryDisabled="true"
      :cancelDisabled="true"
    /> -->
  </div>
</template>


<script>
import ApiErrors from '@/components/common/ApiErrors'
import CreateStudySetOverview from './CreateStudySetOverview'
import StudySetCreateFooter from './StudySetCreateFooter'
import { always, isNil, path, dissoc, pathOr, length, compose, propOr, objOf, map } from 'ramda'
import { mapActions, mapGetters } from 'vuex'
import { successMessage, warningMessage } from '@/utils/messages'
import { STUDY_SET_SKILLS } from '@/constants/studySets'

export default {
  components: {
    ApiErrors,
    CreateStudySetOverview,
    StudySetCreateFooter
  },
  props: {
    studysetDetails: {
      type: Object,
      default: always({ users: [] })
    },
    currentStep: {
      type: Number,
      default: 2
    },
    organizationType: {
      type: String,
      default: ''
    },
    uploadId: {
      default: null
    },
    organizationId: {}
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType'
    })
  },
  data() {
    return {
      showStudentsModal: false,
      showImportModal: false,
      errors: {},
      uploadDetails: {},
      primaryLoading: false,
      review: false,
      createdSuccess: false
    }
  },
  methods: {
    ...mapActions({
      createStudySetAction: 'studysets/createStudySet',
      updateStudySetAction: 'studysets/updateStudySet',
      updateBuildingStudySet: 'studysets/updateBuildingStudySet'
    }),
    openDisplayStudentsModal() {
      this.showStudentsModal = true
    },
    openImportUsersModal() {
      this.showImportModal = true
    },
    async createClass() {
      try {
         this.primaryLoading = this.$loading({
          lock: true,
          text: this.$t('common.loading'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let response
        let phrases = this.studysetDetails.phrases
        let isCreated = this.studysetDetails.created
        if (isCreated) {
          response = await this.updateStudySetAction(this.studysetDetails)
        } else {
          response = await this.createStudySetAction(this.studysetDetails)
        }
        // Item for 4-skills study-set for beta school
        const itemsCreated = response.data.items
        // Phrase for study-set on mobile app
        const phraseCreated = response.data.phrases
        this.createdSuccess = true
        if(length(phrases) != length(phraseCreated)) {
          this.createdSuccess = false
        }
        for (let i = 0; i < phrases.length; i++) {
          if(itemsCreated[i] && itemsCreated[i]["skills_support"])
            phrases[i]["skills_support"] = itemsCreated[i]["skills_support"]
          else
            phrases[i]["skills_support"] = [STUDY_SET_SKILLS.SPEAKING]
          if (phraseCreated[i] != phrases[i].text) {
            phrases[i].warning = true
            phrases[i].original_text = phrases[i].text
            phrases[i].text = phraseCreated[i]
          } else {
            phrases[i].success = true
          }
        }
        
        if (this.createdSuccess) {
          this.$emit('last-step')
          if (isCreated) {
            successMessage(this.$t('study_sets.messages.your_study_set_has_been_updated_successfully'), 'elsa-message success', {
              showClose: false
            })(this)
          } else {
            successMessage(this.$t('study_sets.messages.your_study_set_has_been_created_successfully'), 'elsa-message success', {
              showClose: false
            })(this)
          }
        }
        let x = {
          name: response.data.name,
          category: response.data.category,
          shareable: response.data.shareable,
          owner: response.data.owner,
          organization: response.data.organizationId,
          created: true,
          id: response.data.id,
          phrases: phrases,
          items: response.data.items,
        }

        this.updateBuildingStudySet(x)
        this.primaryLoading.close()
        this.review = true
      } catch (error) {
        this.errors = error
        this.primaryLoading.close()
      }
    },
    reviewDone() {
      return this.$emit('next-step', this.currentStep)
    },
    editClass() {
      this.$emit('edit-step')
    },
    cancelClass() {
      this.$emit('cancel')
    },
    assignToClass() {
      this.$emit('assign-to-class')
    },
    ...mapActions('invite', ['postSentInviteUploadEmails', 'patchInviteUploadEmails', 'getInviteUploadEmails'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

::v-deep .base-create-body {
  margin-top: 35px;
}

::v-deep .base-create-footer {
  margin-top: 24px;
}

::v-deep .generic-error-section {
  margin-bottom: 15px;
}
</style>
